import TabCustomers from './TabCustomers';

export default TabCustomers;
